const Masonry = require( 'masonry-layout' )

export class Masonrylayout {
    constructor ( options ) {
        this.options = options
    }

    init () {
        if ( $( this.options.list_wrapper ).length ) {
            return new Masonry( this.options.list_wrapper )
        }
    }

    layout ( action ) {
        let masonry = null
        if ( $( this.options.list_wrapper ).length > 0 ) {
            masonry = new Masonry( this.options.list_wrapper )
        }
        if ( typeof action === 'undefined' ) {
            return
        }
        if ( masonry === null ) {
            return
        }
        if ( action === 'create' ) {
            return this.create( masonry )
        }
        if ( action === 'update' ) {
            return this.update( masonry )
        }
        if ( action === 'destroy' ) {
            return this.destroy( masonry )
        }
    }

    create ( msr ) {
        return msr
    }

    update ( msr ) {
        return msr.layout()
    }

    destroy ( msr ) {
        return msr.destroy()
    }
}


// WEBPACK FOOTER //
// ./scripts/components/masonry-layout.js